// extracted by mini-css-extract-plugin
module.exports = {"loading":"AuthProvider_loading__-06R2"};